export enum Brands {
  REGUS = 'regus',
  SPACES = 'spaces'
}

// Bump the version suffix and rename the matching CSS file in src/assets/themes/
// whenever a theme's contents change, so deployed clients pick up the new file.
export const THEME_FILES: Record<Brands, string> = {
  [Brands.REGUS]: '_css-variables.regus.v1.css',
  [Brands.SPACES]: '_css-variables.spaces.v1.css',
};
export const SPACES = 'spaces' as const;
export const REGUS = 'regus' as const;

export type Brand = typeof SPACES | typeof REGUS;

export const BRAND_HOSTS: Record<string, string> = {
  [REGUS]: 'regus.com',
  [SPACES]: 'spacesworks.com'
};

export type FooterLinks = Record<string, string>;

export const BRAND_FOOTER_LINKS: FooterLinks = {
    'legal/online-privacy-policy': 'privacyPolicy',
    'legal/client-terms-and-conditions': 'termsAndConditionsSimplified',
    'legal/client-cookie-policy': 'cookiePolicy'
};

export const APP_STORE_LINK = {
  [REGUS]: 'https://itunes.apple.com/gb/app/regus/id387924487?mt=8',
  [SPACES]: 'https://apps.apple.com/ee/app/spaces-creative-workspaces/id1264571107'
};
export const PLAY_STORE_LINK = {
  [REGUS]: 'https://play.google.com/store/apps/details?id=com.regus',
  [SPACES]: 'https://play.google.com/store/apps/details?id=com.spacesworks'
};
